import { useState } from "react";
import { ChevronDown } from "lucide-react";

// Additive FAQ / tyre size guide — inspired by tyreleader.co.uk educational content.
const FAQS = [
  {
    q: "How do I read the size of my tyre?",
    a: "The numbers on the sidewall (e.g. 205/55 R16 91V) tell you everything: 205 is the width in mm, 55 is the aspect ratio (sidewall height as % of width), 16 is the rim diameter in inches, 91 is the load index, and V is the speed rating.",
  },
  {
    q: "When should I change my tyres?",
    a: "The UK legal minimum tread depth is 1.6mm, but we recommend replacing tyres at 3mm for safe wet braking. Also watch for uneven wear, cracks, bulges, or tyres older than 10 years.",
  },
  {
    q: "Do I need summer, winter or all-season tyres?",
    a: "Summer tyres are best above 7°C. Winter tyres provide superior grip below 7°C and on snow/ice. All-season tyres are a sensible compromise for the UK climate, where winters are mild but wet.",
  },
  {
    q: "Do I need to change all four tyres at the same time?",
    a: "For all-wheel-drive vehicles, yes — to avoid transmission damage. For front- or rear-wheel-drive cars you can change by axle, but keep tread depth difference within 5mm on the same axle.",
  },
  {
    q: "What does the EU tyre label mean?",
    a: "All new tyres in the UK carry an EU label showing fuel efficiency (A best → E worst), wet grip (A best → E worst) and external rolling noise (in dB). Higher grades save fuel and improve safety.",
  },
];

const TyreSizeGuide = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="vd-container py-12" data-testid="tyre-size-guide">
      <div className="text-center mb-8">
        <h2 className="mb-2">Tyre Buying Guide</h2>
        <p className="vd-muted max-w-2xl mx-auto">Everything you need to choose the right tyre for your car — from sidewall markings to seasonal advice.</p>
      </div>
      <div className="max-w-3xl mx-auto divide-y" style={{ borderColor: "var(--border-color)" }}>
        {FAQS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className="py-2" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full flex items-center justify-between py-3 text-left"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="vd-heading font-semibold">{f.q}</span>
                <ChevronDown
                  size={20}
                  color="var(--primary-red)"
                  style={{ transform: isOpen ? "rotate(180deg)" : "none", transition: "transform .2s" }}
                />
              </button>
              {isOpen && (
                <p className="vd-muted pb-4 pr-8" data-testid={`faq-answer-${i}`}>{f.a}</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TyreSizeGuide;
